import { BaseApiService } from '@/Services/base-api-service'
import { isAxiosError } from '@/Services/HttpClient/axios-plugin'
import { IPersonPhone } from '../Models/IPersonPhone';
import { ITypedValidationResult } from '../Models/IValidationResult';

class personPhoneService extends BaseApiService {
    public constructor() {
        super('PersonPhone/');
    }

    private static config = {
        headers: {
            'AuthorizationNeeded': true,
            // Other headers can be added here if needed
        }
    };

    public async getByPersonPhoneId(personPhoneId: number, auth0Id: string): Promise<IPersonPhone> {
        return this.httpClient.get<IPersonPhone>(`GetByPersonPhoneId?id=${personPhoneId}&auth0Id=${auth0Id}`, personPhoneService.config).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getByPersonId(personId: number, auth0Id: string): Promise<IPersonPhone> {
        return this.httpClient.get<IPersonPhone>(`GetByPersonId?personId=${personId}&auth0Id=${auth0Id}`, personPhoneService.config).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async savePersonPhone(phone: IPersonPhone, auth0Id: string) {
        console.log('Updating Person Phone');
        this.httpClient.post<ITypedValidationResult<IPersonPhone>>(`SavePersonPhone?auth0Id=${auth0Id}`, phone, personPhoneService.config).catch(this.handleError.bind(this));
    }

}

export const PersonPhoneService: personPhoneService = new personPhoneService();